<template>
  <!-- eslint-disable vue/no-v-html -->
  <q-footer class="text-accent q-pa-xl">
    <div class="container text-body1">
      <div class="row items-center">
        <div
          class="col-xs-12 col-sm-6"
          :class="$q.screen.width < 600 ? 'text-center' : ''"
        >
          <img
            class="logo"
            src="../../../public/logo.svg"
          >
        </div>
        <div
          class="col-xs-12 col-sm-6"
          :class="$q.screen.width < 600 ? 'text-center q-mt-md' : ' text-right'"
        >
          <span class="text-h6 text-weight-bold">s. 517 1818</span>
          <span class="on-right gt-xs">|</span>
          <div class="lt-sm"></div>
          <span
            class="text-weight-medium"
            :class="{
              'on-right': $q.screen.width >= 600
            }"
          >
            americanstyle@americanstyle.is
          </span>
        </div>
      </div>

      <q-separator spaced="xl" />

      <div class="row justify-between q-mt-md">
        <div class="col-xs-12 col-sm-6 col-md-auto q-mb-md">
          <div class="locationTitle">
            American Style Reykjavík
          </div>
          <div class="locationSubtext">
            <div class="q-mb-sm">
              Bíldshöfði 14
            </div>
            <span>110 Reykjavík</span><br>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-auto q-mb-md">
          <div class="locationTitle">
            American Style Reykjavík
          </div>
          <div class="locationSubtext">
            <div class="q-mb-sm">
              Skipholt 70
            </div>
            <span>105 Reykjavík</span><br>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-auto q-mb-md">
          <div class="locationTitle">
            American Style Kópavogur
          </div>
          <div class="locationSubtext">
            <div class="q-mb-sm">
              Nýbýlavegur 22
            </div>
            <span>200 Kópavogur</span><br>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-auto q-mb-md">
          <div class="locationTitle">
            American Style Hafnafjörður
          </div>
          <div class="locationSubtext">
            <div class="q-mb-sm">
              Dalshraun 13
            </div>
            <span>220 Hafnarfjörður</span><br>
          </div>
        </div>
      </div>
      <q-separator spaced="xl" />
      <div class="row justify-between">
        <div class="col-xs-12 col-sm-6 col-md-shrink q-mb-md q-mr-xl">
          <div>
            <q-btn
              class="about q-mb-sm text-body1 text-capitalize"
              flat
              padding="0"
              to="/about"
            >
              Um AMS
            </q-btn> <br>

            <q-btn
              class="about q-mb-sm text-body1 no-capitalization"
              flat
              padding="0"
              to="/application"
            >
              Sækja um starf
            </q-btn> <br>
            <q-btn
              class="q-mb-sm text-body1 no-capitalization"
              flat
              padding="0"
              to="/contact"
            >
              Hafa samband
            </q-btn>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-shrink" >
          <q-btn
            class="q-mb-sm text-body1 text-capitalize"
            flat
            padding="0"
            @click="$router.push({ name: 'Page', params:
              { codename: 'ofnaemisvaldar-american-style' }
            }).catch(() => {})"
          >
            Ofnæmisvaldar
          </q-btn><br>
          <q-btn
            class="text-body1 text-capitalize"
            flat
            padding="0"
            @click="$router.push({ name: 'Page', params:
              { codename: 'jafnlaunastefna-1' }
            }).catch(() => {})"
          >
            Jafnlaunastefna
          </q-btn>
        </div>
        <div
          class="col-xs-12 col-sm-6 col-md-grow social"
          :class="$q.screen.width < 600 ? 'text-center q-mt-xl' : ' text-right'"
        >
          <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'on-left cursor-pointer'" @click="gotoFacebook" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M22.277.705C10.1.705.139 10.645.139 22.887c0 11.069 8.103 20.256 18.684 21.916V29.307H13.2v-6.42h5.623v-4.892c0-5.557 3.299-8.612 8.368-8.612 2.413 0 4.937.42 4.937.42v5.469h-2.79c-2.744 0-3.608 1.704-3.608 3.453v4.162h6.155l-.997 6.42H25.73v15.496a22.138 22.138 0 0018.684-21.916c0-12.242-9.961-22.182-22.137-22.182z" fill="#000"/></svg>

          <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'on-right cursor-pointer'" @click="gotoInstagram" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13.69.705h18.522C39.267.705 45 6.438 45 13.494v18.52a12.788 12.788 0 01-12.788 12.79H13.69C6.635 44.803.902 39.07.902 32.013v-18.52A12.789 12.789 0 0113.69.705zm-.44 4.41a7.938 7.938 0 00-7.938 7.938v19.403a7.933 7.933 0 007.937 7.938h19.404a7.938 7.938 0 007.937-7.938V13.053a7.933 7.933 0 00-7.937-7.938H13.249zm21.277 3.307a2.756 2.756 0 110 5.513 2.756 2.756 0 010-5.513zM22.95 11.73a11.025 11.025 0 110 22.049 11.025 11.025 0 010-22.05zm0 4.41a6.615 6.615 0 100 13.229 6.615 6.615 0 000-13.23z" fill="#000"/></svg>
          <div class="row text-body2">
            <div
              class="col-12"
              :class="$q.screen.width < 600 ? 'text-center q-mt-md' : 'text-right'"
            >
              © Allur réttur áskilinn {{ currentYear }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-footer>
</template>

<script>
import { openURL } from 'quasar';

export default {
  name: 'LayoutFooter',
  data() {
    return {
      page: {},
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    gotoFacebook() {
      openURL('https://www.facebook.com/americanstyleofficial');
    },
    gotoInstagram() {
      openURL('https://www.instagram.com/americanstyle_official/');
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.social {
  path {
    fill: $accent;
  }
}

.locationTitle {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 18px;
}

.locationSubtext {
  font-weight: 400;
  font-size: 16px;
}

.q-separator {
  background: rgba($accent, 10%);
}

.openingHours {
  &::v-deep {
    .flex-row {
      display: flex;
      flex-wrap: wrap;
    }
    .flex-column {
      width: 50%;

      @media only screen and (max-width: 1023px) {
        width: 100%;
      }
    }
  }
}
.no-capitalization {
  text-transform: none;
}
.q-footer {
  background-color: $primary;
  text-transform: none;
}
</style>
